(() => {
  'use strict';

  const STORAGE_KEY = 'POMCollectionBackRestore';
  const GRID_SELECTOR = '#product-grid';
  const PAGINATION_SELECTOR = '.infinite_next';
  const COLLECTION_SELECTOR = '/collections/';
  const PRODUCT_SELECTOR = '/products/';
  const MAX_AGE = 30 * 60 * 1000;

  const currentPath = window.location.pathname;

  if (!currentPath.startsWith(COLLECTION_SELECTOR)) return;

  const currentUrl = window.location.pathname + window.location.search;

  let saveTimer;
  let restoring = false;

  function getGrid() {
    return document.querySelector(GRID_SELECTOR);
  }

  function getPagination() {
    return document.querySelector(PAGINATION_SELECTOR);
  }

  function saveCollectionState() {
    if (restoring) return;

    const grid = getGrid();

    if (!grid) return;

    const pagination = getPagination();

    const state = {
      url: currentUrl,
      scrollY: window.scrollY,
      gridHTML: grid.innerHTML,
      paginationHTML: pagination ? pagination.innerHTML : '',
      timestamp: Date.now()
    };

    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {
      console.warn(
        'POM: Could not save collection state. Browser storage may be full.',
        error
      );
    }
  }

  function scheduleSave() {
    if (restoring) return;

    clearTimeout(saveTimer);

    saveTimer = setTimeout(saveCollectionState, 150);
  }

  function restoreCollectionState() {
    let state;

    try {
      state = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
    } catch (error) {
      return;
    }

    if (!state || state.url !== currentUrl) return;

    if (Date.now() - state.timestamp > MAX_AGE) {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }

    const grid = getGrid();

    if (!grid) return;

    restoring = true;

    // Restore all products previously loaded by Ajaxinate.
    grid.innerHTML = state.gridHTML;

    // Restore the next-page link.
    const pagination = getPagination();

    if (pagination) {
      pagination.innerHTML = state.paginationHTML;
    }

    // Reinitialize Ajaxinate against the restored pagination.
    if (window.endlessCollection &&
        typeof window.endlessCollection.destroy === 'function') {
      window.endlessCollection.destroy();
    }

    window.endlessCollection = new Ajaxinate({
      container: GRID_SELECTOR,
      pagination: PAGINATION_SELECTOR,
      method: 'scroll'
    });

    // Restore scroll after the browser has rendered the products.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.scrollTo(0, state.scrollY);
        restoring = false;
      });
    });
  }

  // Keep the saved state reasonably up to date.
  window.addEventListener('scroll', scheduleSave, { passive: true });

  // Save the complete collection before opening a product.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');

    if (!link || event.defaultPrevented) return;

    const url = new URL(link.href, window.location.origin);

    if (
      url.origin === window.location.origin &&
      url.pathname.startsWith(PRODUCT_SELECTOR)
    ) {
      saveCollectionState();
    }
  });

  // Save state when leaving the collection.
  window.addEventListener('pagehide', saveCollectionState);

  // Restore only when navigating back or forward.
  window.addEventListener('pageshow', (event) => {
    const navigation = performance.getEntriesByType('navigation')[0];

    if (
      event.persisted ||
      (navigation && navigation.type === 'back_forward')
    ) {
      restoreCollectionState();
    }
  });
})();